const enMessages = {
  "nav": {
    "home": "Home",
    "start": "Get Started",
    "learning": "Learning Center",
    "support": "Parent Support",
    "buy": "Buy",
    "about": "About Us",
    "admin": "Admin"
  },
  "hero": {
    "title": "GENIUS AI",
    "subtitle": "Your Child's Smart Language Learning Partner",
    "description": "AI language learning robot designed specifically for children aged 4-13, safe, fun, and effective",
    "cta": "Get Started",
    "learnMore": "Learn More"
  },
  "start": {
    "hero": {
      "title": "Get Started with GENIUS AI",
      "subtitle": "Product Manual + Product Introduction + Usage Guide + Introduction Videos"
  },
  "product": {
      "title": "Product Introduction",
      "description": "Intelligent language learning robot designed specifically for children aged 4-13, featuring a cute circular design with safe silicone casing."
    },
    "setup": {
      "title": "Setup Guide",
      "step1": {
        "title": "Unbox",
        "description": "Open the package and take out the GENIUS AI device"
      },
      "step2": {
        "title": "Power On",
        "description": "Press and hold the power button for 3 seconds to turn on"
      },
      "step3": {
        "title": "Connect",
        "description": "Follow the on-screen instructions to connect to WiFi"
      },
      "step4": {
        "title": "Setup",
        "description": "Create a parent account and set up child profile"
      }
    },
    "videos": {
      "title": "Video Tutorials"
    },
    "faq": {
      "title": "Frequently Asked Questions"
    },
    "features": {
      "design": "Designed for children aged 4-13",
      "safety": "Safe silicone casing", 
      "ai": "AI Teacher Lily companion"
    },
    "showcase": {
      "title": "GENIUS AI Product Showcase"
    },
    "videoList": {
      "intro": "Product Introduction Video",
      "setup": "First Setup Tutorial",
      "features": "Basic Features Introduction"
    },
    "watchVideo": "Watch Video",
    "faqItems": {
      "charge": {
        "question": "How to charge the device?",
        "answer": "Use the included magnetic charger, place it near the bottom of the device for automatic magnetic charging."
      },
      "age": {
        "question": "What age is the device suitable for?",
        "answer": "GENIUS AI is designed for children aged 4-13, providing appropriate learning content for different age groups."
      },
      "setup": {
        "question": "How to set up the device?",
        "answer": "Please refer to the setup guide on the Get Started page, or watch the video tutorials."
      }
    },
    "cta": {
      "title": "Ready to Get Started?",
      "subtitle": "Buy GENIUS AI now, let children start their joyful language learning journey",
      "buy": "Buy Now",
      "learnMore": "Learn More"
    }
  },
  "learning": {
    "hero": {
      "title": "Learning Center",
      "subtitle": "Learning Features + AI Teacher + Educational Framework + Material Downloads"
    },
    "lily": {
      "title": "AI Teacher Lily",
      "description": "Lily is a cute AI teacher who is gentle and patient, good at interacting with children, and can provide personalized learning experiences based on each child's characteristics."
    },
    "framework": {
      "title": "Educational Framework"
    },
    "features": {
      "title": "Learning Features"
    },
    "materials": {
      "title": "Learning Material Downloads",
      "description": "We provide rich downloadable learning materials to help children learn offline and assist parents in teaching."
    },
    "cta": {
      "title": "Online Experience",
      "description": "Experience the power of GENIUS AI and feel the charm of smart learning!",
      "button": "Experience Now"
    },
    "lilyFeatures": [
      "Voice Dialogue",
      "Personalized Teaching",
      "Progress Tracking", 
      "Emotional Companion"
    ],
    "lilyName": "Teacher Lily",
    "learningFeatures": [
      {
        "title": "Vocabulary Learning",
        "description": "Learn new vocabulary through pictures, pronunciation and interactive games"
      },
      {
        "title": "Dialogue Practice",
        "description": "Practice real-scenario dialogues with AI Teacher Lily"
      },
      {
        "title": "Story Reading",
        "description": "Rich bilingual story library to enhance reading interest"
      },
      {
        "title": "Interactive Games",
        "description": "Consolidate learning through fun games"
      }
    ],
    "ageGroups": [
      {
        "age": "4-6 years",
        "title": "Foundation Stage",
        "description": "Basic vocabulary learning and pronunciation practice through nursery rhymes and simple stories"
      },
      {
        "age": "6-10 years",
        "title": "Elementary Stage", 
        "description": "Daily dialogue practice and scenario simulation, expanding vocabulary and grammar knowledge"
      },
      {
        "age": "10-13 years",
        "title": "Advanced Stage",
        "description": "Advanced language learning and cultural exploration, developing independent thinking and expression skills"
      }
    ],
    "downloads": [
      {
        "name": "Learning Cards (PDF)",
        "description": "Printable learning cards to help children learn offline"
      },
      {
        "name": "Workbook (PDF)",
        "description": "Matching workbook to consolidate learning results"
      },
      {
        "name": "Teacher Lily Wallpaper (JPG)",
        "description": "Cute Teacher Lily wallpaper to make children love more"
      }
    ],
    "downloadButton": "Download",
    "startButton": "Get Started"
  },
  "support": {
    "hero": {
      "title": "Parent Support",
      "subtitle": "Parent Guide + Help Center + Interaction Guide"
    },
    "philosophy": {
      "title": "Educational Philosophy",
      "vision": {
        "title": "Educational Vision",
        "description": "Enable every child aged 4-13 to enjoy safe, fun, and personalized language learning experiences"
      },
      "safety": {
        "title": "Safety Assurance",
        "description": "Device uses food-grade silicone material, blue-light-free eye protection screen, strict content control"
      },
      "effectiveness": {
        "title": "Learning Effectiveness",
        "description": "Through AI personalized teaching and gamified interaction, significantly improve children's language learning interest"
      }
    },
    "control": {
      "title": "Parent Support Features"
    },
    "experts": {
      "title": "Expert Recommendations"
    },
    "faq": {
      "title": "Frequently Asked Questions"
    },
    "contact": {
      "title": "Contact Us",
      "description": "We serve you 24/7"
    },
    "tips": {
      "title": "Interaction Tips"
    },
    "parentFeatures": [
      {
        "title": "Usage Time Recommendations",
        "description": "Recommended daily usage time to protect children's eye health"
      },
      {
        "title": "Learning Progress Viewing",
        "description": "View children's learning progress and achievements"
      },
      {
        "title": "Content Safety Filtering",
        "description": "Ensure all learning content is suitable for children"
      },
      {
        "title": "Device Management",
        "description": "Manage device settings through mobile APP"
      },
      {
        "title": "Learning Reports",
        "description": "Generate detailed learning reports regularly"
      },
      {
        "title": "Goal Setting",
        "description": "Set learning goals and rewards for children"
      }
    ],
    "expertTestimonials": [
      {
        "title": "Child Psychology Expert",
        "quote": "GENIUS AI's design fully considers children's cognitive development characteristics, and its interaction methods can effectively stimulate children's learning interest."
      },
      {
        "title": "Language Education Professor",
        "quote": "This robot provides children with an immersive language environment and is a powerful supplement to traditional teaching."
      }
    ],
    "faqItems": [
      {
        "question": "How to set up the device?",
        "answer": "Please refer to the setup guide on the Get Started page or watch video tutorials."
      },
      {
        "question": "How to interact with children?",
        "answer": "It is recommended that parents accompany children to use the device together, encourage children to talk with Teacher Lily, and regularly check learning progress."
      },
      {
        "question": "How to view learning progress?",
        "answer": "You can view children's learning progress and achievements through the device screen."
      },
      {
        "question": "How to set usage time?",
        "answer": "It is recommended that parents arrange usage time reasonably according to children's age to protect children's eye health."
      },
      {
        "question": "How to contact customer service?",
        "answer": "You can contact our customer service team via email, phone or WhatsApp, we serve you 24 hours a day."
      }
    ],
    "contactInfo": {
      "email": "Email",
      "phone": "Phone",
      "serviceTime": "Service Hours",
      "serviceHours": "Monday to Friday 9:00-18:00"
    },
    "interactionTips": [
      {
        "title": "Learn Together",
        "content": "Spend 15-30 minutes with your child using GENIUS AI every day, participating in their learning process."
      },
      {
        "title": "Encourage Expression",
        "content": "Encourage children to speak boldly, even if there are mistakes, give positive feedback."
      },
      {
        "title": "Create Context",
        "content": "Create language usage scenarios in daily life, such as watching bilingual animations together, playing role-playing games."
      },
      {
        "title": "Patient Guidance",
        "content": "When children encounter difficulties, give patient guidance instead of directly providing answers."
      }
    ]
  },
  "buy": {
    "hero": {
      "title": "Choose Your Package",
      "subtitle": "Choose the learning package that best suits your child, start your smart learning journey"
    },
    "plans": {
      "title": "Choose Package"
    },
    "package": {
      "title": "GENIUS AI",
      "subtitle": "Complete Learning Features",
      "price": "Rp 499,000",
      "originalPrice": "Rp 899,000",
      "discount": "Limited Time Offer",
      "savings": "Save Rp 400,000",
      "features": [
        "Complete Learning Features",
        "AI Teacher Lily",
        "All Learning Content",
        "Lifetime Free Use",
        "Safe Design"
      ],
      "buyButton": "Buy Now"
    },
    "showcase": {
      "title": "Product Showcase"
    },
    "benefits": {
      "discount": {
        "title": "🎁 Limited Time Offer",
        "description": "Buy now and enjoy limited time offer price, save Rp 400,000!"
      },
      "shipping": {
        "title": "🚚 Free Shipping",
        "description": "Free shipping across Indonesia, ships within 7 days, supports cash on delivery."
      },
      "warranty": {
        "title": "🛡️ Quality Guarantee",
        "description": "1 year warranty, 30 days no reason return, worry-free purchase."
      }
    },
    "process": {
      "title": "Purchase Process",
      "steps": [
        {
          "title": "Choose Package",
          "description": "Choose the learning package suitable for your child"
        },
        {
          "title": "Fill Information",
          "description": "Fill in delivery address and contact information"
        },
        {
          "title": "Pay Order",
          "description": "Choose payment method to complete payment"
        },
        {
          "title": "Start Learning",
          "description": "Start your learning journey after receiving the product"
        }
      ]
    },
    "cta": {
      "title": "Buy GENIUS AI Now",
      "subtitle": "Buy now and enjoy limited time offer, let children start their joyful language learning journey!",
      "buyButton": "Buy Now - Rp 499,000",
      "learnMoreButton": "Learn More"
    }
  },
  "about": {
    "hero": {
      "title": "About Us",
      "subtitle": "Dedicated to making children's language learning more fun, safe, and effective"
    },
    "mission": {
      "title": "Mission",
      "description": "Enable every child aged 4-13 to enjoy safe, fun, and personalized language learning experiences, making learning more interesting and effective through AI technology."
    },
    "vision": {
      "title": "Vision",
      "description": "Become Indonesia's leading provider of smart language learning solutions for children, promoting innovation and development in educational technology, enabling every child to learn happily."
    },
    "team": {
      "title": "Core Team"
    },
    "value": {
      "title": "Core Values"
    },
    "history": {
      "title": "Development History"
    },
    "partner": {
      "title": "Indonesian Partners"
    },
    "contact": {
      "title": "Contact Us"
    },
    "cta": {
      "title": "Join Our Team",
      "description": "We are looking for talented partners to create a better future for children's learning together",
      "buttonPrimary": "Learn About Product",
      "buttonSecondary": "Join Us"
    },
    "teamMembers": [
      {
        "name": "Dr. Zhang",
        "role": "CEO & Founder",
        "description": "Children's education expert with 15 years of experience in the education industry, focusing on AI education technology R&D.",
        "avatar": "👨‍💼"
      },
      {
        "name": "Engineer Li",
        "role": "CTO & Technical Director",
        "description": "AI technology expert, former Google engineer, focusing on child-safe AI technology development.",
        "avatar": "👨‍💻"
      },
      {
        "name": "Designer Wang",
        "role": "Design Director",
        "description": "Children's product design expert, focusing on child-friendly interface design and user experience.",
        "avatar": "👩‍🎨"
      }
    ],
    "values": [
      {
        "icon": "🛡️",
        "title": "Safety First",
        "description": "Children's safety is our most important consideration, all products undergo strict safety testing."
      },
      {
        "icon": "👥",
        "title": "User-Centric",
        "description": "Centered on the needs of children and parents, continuously optimizing product experience."
      },
      {
        "icon": "🚀",
        "title": "Continuous Innovation",
        "description": "Continuously exploring new technologies, integrating cutting-edge technologies like AI and speech recognition into education."
      },
      {
        "icon": "🤝",
        "title": "Team Collaboration",
        "description": "Believing in the power of teamwork, creating better products through collaboration."
      }
    ],
    "timeline": [
      {
        "year": "2022",
        "title": "Company Founded",
        "description": "Company founded, focusing on children's AI education technology R&D, received angel round investment."
      },
      {
        "year": "2023",
        "title": "Product Development",
        "description": "Completed Series A funding, team expanded to 50 people, GENIUS AI product prototype development completed."
      },
      {
        "year": "2024",
        "title": "Product Launch",
        "description": "GENIUS AI product officially launched, received widespread praise from Indonesian users, user count exceeded 10,000."
      },
      {
        "year": "Future",
        "title": "Expansion Plan",
        "description": "Planning to expand to more Southeast Asian countries, becoming the leading children's smart learning platform in the region."
      }
    ],
    "partners": [
      {
        "name": "Indonesian Education Group",
        "description": "Partnering with Indonesia's largest education group to provide customized solutions for schools.",
        "logo": "🏫"
      },
      {
        "name": "Jakarta Tech Park",
        "description": "Located in Jakarta Tech Park, enjoying policy support and industry resources.",
        "logo": "🏢"
      },
      {
        "name": "Retail Partners",
        "description": "Partnering with major Indonesian retailers to expand product sales channels.",
        "logo": "🛒"
      }
    ],
    "contactInfo": {
      "email": "Email",
      "phone": "Phone",
      "address": "Address",
      "location": "Kirana Three Office Tower, Jakarta",
      "viewOnMaps": "View on Google Maps"
    }
  },
  "features": {
    "title": "Why Choose GENIUS AI?",
    "lily": {
      "title": "AI Teacher Lily",
      "description": "Cute AI teacher for learning companion, gentle and patient, good at interacting with children"
    },
    "safety": {
      "title": "Safe & Reliable",
      "description": "Safety features designed specifically for children, food-grade silicone material, parents can rest assured"
    },
    "fun": {
      "title": "Fun Learning",
      "description": "Learn languages through gamification, making children love learning"
    }
  },
  "testimonials": {
    "title": "Parent Recommendations",
    "sarah": {
      "name": "Sarah's Mom",
      "location": "Jakarta",
      "quote": "My child loves Teacher Lily very much, and the learning effect is great! The device is very safe, and I feel completely at ease letting my child use it."
    },
    "michael": {
      "name": "Michael's Dad",
      "location": "Surabaya", 
      "quote": "GENIUS AI has made my child very interested in learning Chinese, and they look forward to talking with Teacher Lily every day."
    }
  },
  "cta": {
    "title": "Ready to Get Started?",
    "subtitle": "Buy GENIUS AI now, let children start their joyful language learning journey",
    "button": "Buy Now",
    "learnMore": "Learn More"
  },
  "footer": {
    "description": "GENIUS AI - Smart Language Learning Robot for Children Aged 4-13",
    "rights": "All rights reserved © 2024 GENIUS AI",
    "tagline": "Making learning more fun.",
    "developedBy": "Developed by Infant.AI company",
    "privacyPolicy": "Privacy Policy",
    "termsOfService": "Terms of Service",
    "cookiePolicy": "Cookie Policy"
  }
}

export default enMessages
